<template>
	<div>
		<template v-for="(trigger, i) in scene.triggers">
			<div v-if="i != 0" :key="`divider--${trigger.guid}-${i}`" class="pa-6">
				<v-divider />
			</div>
			<Trigger
				:key="`trigger--${trigger.guid}-${i}`"
				:trigger="trigger"
				:scene="scene"
			/>
		</template>
	</div>
</template>

<script>
import Trigger from "./Trigger";

export default {
	components: {
		Trigger,
	},
	props: {
		scene: Object,
	},
};
</script>
